import { useMutation } from "@tanstack/react-query";
import type { components } from "@/shared/lib/api.types";
import { api, unwrap } from "@/shared/lib/apiClient";

type CreateInviteRequest = components["schemas"]["CreateInviteRequest"];

// Nothing to invalidate — invites aren't listed anywhere.
export function useCreateInvite() {
  return useMutation({
    mutationFn: async (body: CreateInviteRequest) =>
      unwrap(await api.POST("/api/invites", { body })),
  });
}
